<template>
  <div>
    <div class="miss-word-text">
      <div class="inline-words">
        <span
          v-for="(variant, key) in work.metadata.variants"
          :key="key"
          v-html="$options.filters.breakSpace(variant.value)"
          :class="`${variant.type === 'answer' ? 'q-miss-word-answer' : 'q-miss-word-simple'}`"
          :title="`Верный ответ: ${variant.correctValue}`"
        ></span>
      </div>
    </div>
    <span class="badge badge-danger m-t-3">{{
      check ? "Правильно" : "Неправильно"
    }}</span>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: ["data", "work"],
  computed: {
    check() {
      let isCorrect = true;

      let decision = this.work.decisions;
      let variants = this.work.metadata.variants.filter((item) => {
        return item.type === "answer";
      });

      if (decision.length === 0 || variants.length === 0)
        return false

      for (let i = 0; i < decision.length; i++) {
        if (decision[i].answer !== variants[i].value) {
          isCorrect = false;
          break
        }
      }

      return isCorrect;
    },
  },
};
</script>
